<div
  *ngIf="control"
  class="form-group"
  [class.required]="isRequired"
  [class.disabled]="isDisabled"
  [formGroup]="parentForm"
  [class.inline]="isInline"
>
  <mat-radio-group [formControlName]="formControlName" class="radio-group-checkboxes">
    <mat-radio-button class="radio-button-checkboxes" *ngFor="let item of collection" [value]="item[keyPropertyName]">
      <span class="fs-14" [innerHTML]="item[valuePropertyName]"></span>
    </mat-radio-button>
  </mat-radio-group>
</div>
